import React from 'react';

const SvgWeather = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="29"
    viewBox="0 0 36 29"
    fill="none"
    {...props}
  >
    <path
      d="M31.9563 18.1676C31.9672 18.0637 32 17.9653 32 17.8614C32 15.9313 30.4305 14.3621 28.5 14.3621C27.8109 14.3621 27.1766 14.5699 26.6352 14.9089C25.6727 12.7874 23.5453 11.3002 21.0625 11.3002C17.6828 11.3002 14.9375 14.0395 14.9375 17.424C14.9375 17.588 14.9758 17.7411 14.9867 17.8997C12.2742 18.102 10.125 20.3438 10.125 23.1104C10.125 26.0083 12.4766 28.3594 15.375 28.3594H30.25C33.1484 28.3594 35.5 26.0083 35.5 23.1104C35.5 20.8085 34.0125 18.8784 31.9563 18.1676ZM8.41875 16.9319C6.02891 14.5425 6.02891 10.6605 8.41875 8.27658C10.8086 5.8872 14.6914 5.8872 17.0813 8.27658C17.6117 8.80694 18.0055 9.41932 18.3008 10.0645C18.8367 9.86221 19.4 9.73645 19.9797 9.65444L21.6094 4.79367C21.8281 4.14301 21.2102 3.53063 20.5594 3.74387L15.7578 5.3459L13.4883 0.81866C13.1875 0.20628 12.3125 0.20628 12.0062 0.81866L9.74219 5.3459L4.93516 3.74387C4.28984 3.53063 3.67188 4.14848 3.88516 4.79367L5.4875 9.59429L0.959375 11.8634C0.346875 12.1696 0.346875 13.0389 0.959375 13.3451L5.4875 15.6087L3.88516 20.4094C3.66641 21.06 4.28437 21.6724 4.93516 21.4592L9.09688 20.0758C9.43047 19.3978 9.8625 18.78 10.3875 18.2442C9.67109 17.9489 8.99844 17.5115 8.41875 16.9319ZM8.15625 12.6015C8.15625 14.8323 9.75859 16.6913 11.8695 17.1014C12.307 16.8444 12.7609 16.6203 13.2477 16.4617C13.543 14.0395 14.943 11.9509 16.9336 10.7206C16.2117 9.12954 14.6094 8.01413 12.75 8.01413C10.218 8.01413 8.15625 10.07 8.15625 12.6015Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgWeather;
